// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1ryTc","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__EnQHl"};